import { render, staticRenderFns } from "./app-image-lightbox.vue?vue&type=template&id=b3c148ee"
import script from "./app-image-lightbox.vue?vue&type=script&lang=ts"
export * from "./app-image-lightbox.vue?vue&type=script&lang=ts"
import style0 from "./app-image-lightbox.vue?vue&type=style&index=0&id=b3c148ee&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/volateq-web-app/volateq-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3c148ee')) {
      api.createRecord('b3c148ee', component.options)
    } else {
      api.reload('b3c148ee', component.options)
    }
    module.hot.accept("./app-image-lightbox.vue?vue&type=template&id=b3c148ee", function () {
      api.rerender('b3c148ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/app-image-lightbox/app-image-lightbox.vue"
export default component.exports